<template>
  <credit-widget
    id="loan-insights"
    class="loan-insights"
    data-testid="loan-insights-widget"
  >
    <template #widget-header>
      <div
        class="d-flex flex-grow-1 justify-content-between align-items-center"
      >
        <div class="d-flex i-gap-sm align-items-center">
          <i-icon
            class="icon i-text-neutral-110"
            symbol="small-money-bank"
            :size="16"
          ></i-icon>
          <span>Loan Insights</span>
        </div>
        <div
          role="button"
          data-testid="view-loan-insights-button"
          @click="viewLoanInsights"
        >
          <i-badge
            class="i-ml-4"
            :colour="iBadgeColours.PRIMARY"
            label="View"
            interactable
            alt-text-colour
            has-trailing-icon
            icon="small-arrows-right-small"
            @right-icon-click="viewLoanInsights"
          />
        </div>
      </div>
    </template>
    <template #widget-content>
      <div class="line large">
        <span>Total Loan Repayments</span>
        <credit-widget-value
          :value="totalLoanRepayments"
          :currency="true"
        ></credit-widget-value>
      </div>
      <div class="line">
        <span>Count of Loan Repayments</span>
        <credit-widget-value :value="countLoanRepayments"></credit-widget-value>
      </div>
      <div class="line">
        <span>Total Loan Disbursements</span>
        <credit-widget-value
          :value="totalLoanDisbursements"
          :currency="true"
        ></credit-widget-value>
      </div>
      <div class="line">
        <span>Count of Loan Disbursements</span>
        <credit-widget-value
          :value="countLoanDisbursements"
        ></credit-widget-value>
      </div>
    </template>
  </credit-widget>
</template>

<script>
import { mapState } from 'vuex';
import { iIcon, iBadge, iBadgeColours } from '@inscribe/signal';
import CreditWidget from '@/V2/credit/widgets/CreditWidget';
import CreditWidgetValue from '@/V2/credit/widgets/CreditWidgetValue';
import { LOAN_INSIGHTS_SLUG } from '@/V2/credit/granular-insights/constants';
import { getAndSyncQueryParams } from '@/utils/queryParams';
import { getUseAllDocsQueryParameter } from '@/V2/credit/utils';

export default {
  name: 'LoanInsights',
  components: { CreditWidget, CreditWidgetValue, iIcon, iBadge },
  data() {
    return {
      iBadgeColours,
      params: getAndSyncQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
      }),
    };
  },
  computed: {
    ...mapState({
      credit: 'credit',
    }),
    countLoanDisbursements() {
      return this.credit?.customerLoan?.count_loan_disbursements;
    },
    countLoanRepayments() {
      return this.credit?.customerLoan?.count_loan_repayments;
    },
    lenderName() {
      if (
        this.credit?.customerLoan &&
        this.credit.customerLoan.loans !== undefined
      ) {
        return Object.keys(this.credit.customerLoan.loans)[0];
      }
      return undefined;
    },
    totalLoanDisbursements() {
      return this.credit?.customerLoan?.total_loan_disbursements;
    },
    totalLoanRepayments() {
      return this.credit?.customerLoan?.total_loan_repayments;
    },
    useAllDocsQueryParameter() {
      return getUseAllDocsQueryParameter(this.params);
    },
  },
  watch: {
    '$route.fullPath': {
      handler: function (newFullPath) {
        this.params = getAndSyncQueryParams({
          fullPath: newFullPath,
          router: this.$router,
          store: this.$store,
        });
      },
    },
  },
  methods: {
    viewLoanInsights() {
      this.$router.push({
        name: 'customer-credit-granular-insight',
        params: {
          type: LOAN_INSIGHTS_SLUG,
        },
        query: {
          use_all_docs: this.useAllDocsQueryParameter,
        },
      });
    },
  },
};
</script>
